export default{
	  bind: function (el, binding, vnode) {
		  el.dataset.oldval=el.value
		  var className=binding.value.class || "numerror";
		  var closeTime=function(event,delaytime){
			  setTimeout(function(){
					event.target.dataset.tooltip = '';
					var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');  
					event.target.className = event.target.className.replace(reg, ' ');  
				},delaytime || 3000)
		  }
			var input=function(event) {
			  console.log('新：',event.target.value,'旧',event.target.dataset.oldval)
			 
                if (event.target.value >parseFloat(event.target.max) || event.target.value <parseFloat(event.target.min)) {
                    event.target.dataset.tooltip = '值必须大于' + event.target.min + ',小于等于' + event.target.max + '。';
					UI.showTooltip(event.target)
					event.target.className +=' '+className;  
					closeTime(event)
                    event.target.value =  event.target.dataset.oldval
                    return false;
                }
				if(event.target.value!="")event.target.dataset.oldval=event.target.value;//保留小数
            }.bind(this)
			el.addEventListener('change',input)
			var change=function(event) {
				 if (event.target.value == '') {
                    event.target.dataset.tooltip = '值不能为空';
					UI.showTooltip(event.target)
					event.target.className +=' '+className; 				
					closeTime(event)
                    event.target.value =  event.target.dataset.oldval
                    return false;
                }
			 }.bind(this)
			el.addEventListener('change',change)
	  },  
	}


// WEBPACK FOOTER //
// ./src/vue/directive/v-mynumber.js